<div class="fixed z-[100] flex flex-col-reverse w-full pointer-events-none
            bottom-0 left-0 px-4 pb-6
            sm:bottom-6 sm:right-6 sm:left-auto sm:px-0 sm:pb-0 sm:max-w-sm">

  @for (msg of messageService.messages(); track msg.id) {
    <div
      class="pointer-events-auto relative overflow-hidden flex items-center p-4 rounded-2xl shadow-2xl border bg-white dark:bg-gray-800 message-toast w-full"
      [ngClass]="{
        'border-green-500/20': msg.type === 'success',
        'border-red-500/20': msg.type === 'error',
        'border-amber-500/20': msg.type === 'warning',
        'border-blue-500/20': msg.type === 'info',
        'leaving': msg.isLeaving
      }">

      <div class="mr-3 flex items-center justify-center shrink-0">
        @switch (msg.type) {
          @case ('success') { <i class="fa-solid fa-circle-check text-green-500 text-xl"></i> }
          @case ('error') { <i class="fa-solid fa-circle-xmark text-red-500 text-xl"></i> }
          @case ('warning') { <i class="fa-solid fa-triangle-exclamation text-amber-500 text-xl"></i> }
          @case ('info') { <i class="fa-solid fa-circle-info text-blue-500 text-xl"></i> }
        }
      </div>

      <p class="text-sm font-bold flex-1 text-gray-900 dark:text-white leading-tight py-1">
        {{ msg.text }}
      </p>

      <button (click)="messageService.remove(msg.id)"
              class="ml-2 shrink-0 text-gray-400 hover:text-gray-600 dark:hover:text-white cursor-pointer p-1 flex items-center justify-center">
        <i class="fa-solid fa-xmark text-lg"></i>
      </button>

      <div
        class="absolute top-0 left-0 h-1"
        [ngClass]="{
          'bg-green-500': msg.type === 'success',
          'bg-red-500': msg.type === 'error',
          'bg-amber-500': msg.type === 'warning',
          'bg-blue-500': msg.type === 'info'
        }"
        [style.animation]="msg.isLeaving ? 'none' : 'progress-shrink ' + msg.duration + 'ms linear forwards'">
      </div>
    </div>
  }
</div>
